import { Button, Card } from 'antd';
import { BackButton } from '../../uiComponents/BackButton';
import { ConsignmentOrderBillingTable } from '../../components/ConsignmentOrderBilling/ConsignmentOrderBillingTable';
import { PlusOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { UrlPaths } from '../../../constants';

export const ConsignOrderBilling = () => {
  const navigate = useNavigate();
  const { id, numberOrder } = useParams();
  const titleLabel = `Factura de Consigna CN${numberOrder}`;
  const {
    privileges: { consignmentOrder = [] },
    role = null,
  } = useSelector((state) => state.userAuth);
  return (
    <Card
      title={
        <BackButton path={UrlPaths.CONSIGNMENT_ORDER} label={titleLabel} />
      }
      bordered={true}
      className="gx-card"
    >
      {consignmentOrder.includes('create') && (
        <Button
          type="primary"
          htmlType="submit"
          onClick={() => {
            navigate(
              UrlPaths.CONSIGNMENT_ORDER_BILLING_CREATE(id, numberOrder)
            );
          }}
        >
          <PlusOutlined />
          Nueva Factura
        </Button>
      )}
      <ConsignmentOrderBillingTable
        privileges={consignmentOrder}
        role={role}
        numberOrder={numberOrder}
      />
    </Card>
  );
};
